import { createSelector } from '@reduxjs/toolkit';

import { useAppSelector } from 'src/hooks/useStore';
import { useGetNotificationsSettingsQuery } from 'src/services/api';
import { RootState } from 'src/store';

const selectTotalUnreadMessagesCount = createSelector(
  [
    (state: RootState) => state.messages.totalUnreadMessagesByCompany,
    (state: RootState) => state.activeCompany.activeCompanyId,
    (state: RootState) => state.user.isClient,
    (state: RootState) => state.messages.totalUnreadMessages,
  ],
  (
    totalUnreadMessagesByCompany,
    activeCompanyId,
    isClientUser,
    totalUnreadMessages,
  ) => {
    if (!isClientUser) {
      return totalUnreadMessages || 0;
    }

    if (totalUnreadMessagesByCompany && activeCompanyId) {
      return totalUnreadMessagesByCompany[activeCompanyId] || 0;
    }

    return 0;
  },
);

export const useMessagesNotificationCount = (): number => {
  const isClientUser = useAppSelector((state) => state.user.isClient);

  const totalUnreadMessagesCount = useAppSelector(
    selectTotalUnreadMessagesCount,
  );

  const { data: notificationSettings } = useGetNotificationsSettingsQuery(
    undefined,
    {
      skip: isClientUser,
    },
  );
  const disabledProductNotification = notificationSettings?.disableInProduct;
  const disableMessagesNotifications =
    notificationSettings?.notifyAbout.newMessages.disableInProduct;

  if (disabledProductNotification || disableMessagesNotifications) return 0;

  return totalUnreadMessagesCount;
};
